import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import api from "../../config/URL";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const validationSchema = Yup.object().shape({
  courseId: Yup.string().required("*Select a Current Course"),
  classId: Yup.string().required("*Select a Current Class"),
  lastLessonDate: Yup.string().required("*Select a Last Lesson"),
  reason: Yup.string().required("*Select a Reason"),
  centerRemark: Yup.string()
    .required("*Centre Remark is required")
    .max(200, "*The maximum length is 200 characters"),
});

const StudentEndClassAdd = ({
  getData,
  id,
  centerId,
  courseId,
  classId,
  reason,
}) => {
  const [courseData, setCourseData] = useState(null);
  const [classData, setClassData] = useState(null);
  const [show, setShow] = useState(false);
  const [loadIndicator, setLoadIndicator] = useState(false);
  const [lastLessonDateData, setLastLessonDateData] = useState(null);
  const userName = localStorage.getItem("userName");

  const handleClose = () => {
    formik.resetForm();
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
    fetchCourseData();

    formik.setFieldValue("courseId", courseId || "");
    formik.setFieldValue("classId", classId || "");

    // ✅ SET REASON FROM DROPDOWN
    if (reason) {
      formik.setFieldValue("reason", reason);
    }

    if (courseId) fetchClasses(courseId);
    if (classId) fetchlastLessonData(classId);
  };

  const formik = useFormik({
    initialValues: {
      centerId: centerId || "",
      courseId: courseId || "",
      classId: classId || "",
      studentId: id || "",
      lastLessonDate: "",
      preferStartDate: "",
      reason: reason,
      otherReason: "",
      centerRemark: "",
      parentRemark: "",
      createdBy: userName,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoadIndicator(true);
      try {
        const response = await api.post(
          "/createStudentEndClassForECS",
          values,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.status === 201) {
          toast.success(response.data.message);
          handleClose();
          getData();
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        if (error?.response?.status === 409) {
          toast.warning(error?.response?.data?.message);
        } else if (error?.response?.status === 404) {
          toast.warning(error?.response?.data?.message);
        } else {
          toast.error(error?.response?.data?.message || "An error occurred");
        }
      } finally {
        setLoadIndicator(false);
      }
    },
  });

  const handleClassChange = (e) => {
    const newClassId = e.target.value;
    formik.setFieldValue("classId", newClassId);
    if (newClassId) {
      fetchlastLessonData(newClassId);
    }
  };

  const fetchlastLessonData = async (selectedClassId) => {
    try {
      const response = await api.get(
        `getLastLessonClassDate?classId=${selectedClassId}&studentId=${id}`
      );
      setLastLessonDateData(response.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const fetchCourseData = async () => {
    try {
      // const course = await fetchAllCoursesWithIdsC(centerId);
      const response = await api.get(
        `getCourseIdsAndNamesByCenterId/${centerId}?studentId=${id}`
      );
      setCourseData(response.data);
    } catch (error) {
      toast.error(error);
    }
  };

  const handleCourseChange = (event) => {
    const newCourseId = event.target.value;
    formik.setFieldValue("courseId", newCourseId);
    formik.setFieldValue("classId", ""); // Reset classId when course changes
    fetchClasses(newCourseId);
  };

  const fetchClasses = async (courseId) => {
    try {
      const response = await api.get(
        `getClassIdsAndNamesByCourseId/${courseId}?studentId=${id}`
      );
      setClassData(response.data);
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (centerId) {
      formik.setFieldValue("centerId", centerId);
    }
  }, [centerId]);

  const formatEnumLabel = (value = "") =>
    value
      .toLowerCase() // END_CLASS → end_class
      .replace(/_/g, " ") // end_class → end class
      .replace(/^./, (c) => c.toUpperCase()); // End class

  return (
    <>
      <li className="dropdown-item" onClick={handleShow}>
        {formatEnumLabel(reason)}
      </li>

      <Modal show={show} centered onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <p className="headColor">Student End Class</p>
          </Modal.Title>
        </Modal.Header>
        <form
          onSubmit={formik.handleSubmit}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !formik.isSubmitting) {
              e.preventDefault();
            }
          }}
        >
          <div className="container-fluid px-4">
            <div className="row">
              <div className="col-md-6 col-12 mb-4">
                <label className="form-label m-0">
                  Current Course <span className="text-danger">*</span>
                </label>
                <select
                  {...formik.getFieldProps("courseId")}
                  value={formik.values.courseId}
                  className={`form-select  ${
                    formik.touched.courseId && formik.errors.courseId
                      ? "is-invalid"
                      : ""
                  }`}
                  onChange={handleCourseChange}
                >
                  <option disabled></option>
                  {courseData &&
                    courseData.map((course) => (
                      <option key={course.id} value={course.id}>
                        {course.courseNames}
                      </option>
                    ))}
                </select>
                {formik.touched.courseId && formik.errors.courseId && (
                  <div className="invalid-feedback">
                    {formik.errors.courseId}
                  </div>
                )}
              </div>

              <div className="col-md-6 col-12 mb-4">
                <lable className="form-lable">
                  Current Class<span className="text-danger">*</span>
                </lable>
                <select
                  {...formik.getFieldProps("classId")}
                  className={`form-select  ${
                    formik.touched.classId && formik.errors.classId
                      ? "is-invalid"
                      : ""
                  }`}
                  // onChange={handleClassChange}
                  onChange={handleClassChange}
                  onBlur={formik.handleBlur}
                >
                  <option selected></option>
                  {classData &&
                    classData.map((classes) => (
                      <option key={classes.id} value={classes.id}>
                        {classes.classNames}
                      </option>
                    ))}
                </select>
                {formik.touched.classId && formik.errors.classId && (
                  <div className="invalid-feedback">
                    {formik.errors.classId}
                  </div>
                )}
              </div>

              <div className="col-md-6 col-12 mb-4">
                <label>
                  Last Lesson Date<span className="text-danger">*</span>
                </label>
                <select
                  name="lastLessonDate"
                  value={formik.values.lastLessonDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`form-select ${
                    formik.touched.lastLessonDate &&
                    formik.errors.lastLessonDate
                      ? "is-invalid"
                      : ""
                  }`}
                >
                  <option value="">Select Date</option>
                  {lastLessonDateData &&
                    lastLessonDateData.map((lastLessonDate) => (
                      <option key={lastLessonDate.id} value={lastLessonDate.id}>
                        {lastLessonDate.startDate}
                      </option>
                    ))}
                </select>
                {formik.touched.lastLessonDate &&
                  formik.errors.lastLessonDate && (
                    <div className="invalid-feedback">
                      {formik.errors.lastLessonDate}
                    </div>
                  )}
              </div>
              {/* <div className="col-md-6 col-12 mb-2">
                <lable className="form-lable">
                  Reason<span className="text-danger">*</span>
                </lable>
                <select
                  {...formik.getFieldProps("reason")}
                  className={`form-select ${
                    formik.touched.reason && formik.errors.reason
                      ? "is-invalid"
                      : ""
                  }`}
                  disabled={!!reason} // 👈 IMPORTANT
                >
                  <option value=""></option>
                  <option value="Suspend">Suspend</option>
                  <option value="Graduate">Graduate</option>
                  <option value="Change Class">Change Class</option>
                </select>
                {formik.touched.reason && formik.errors.reason && (
                  <div className="invalid-feedback">{formik.errors.reason}</div>
                )}
              </div> */}
              <div className="col-md-6 col-12 mb-2">
                <lable className="form-lable">Parent Remark</lable>

                <textarea
                  className={`form-control   ${
                    formik.touched.parentRemark && formik.errors.parentRemark
                      ? "is-invalid"
                      : ""
                  }`}
                  {...formik.getFieldProps("parentRemark")}
                ></textarea>
                {formik.touched.parentRemark && formik.errors.parentRemark && (
                  <div className="invalid-feedback">
                    {formik.errors.parentRemark}
                  </div>
                )}
              </div>
              <div className="col-md-6 col-12 ">
                <div className=" mb-4">
                  <lable className="form-lable">Other Reason</lable>

                  <textarea
                    className={`form-control   ${
                      formik.touched.otherReason && formik.errors.otherReason
                        ? "is-invalid"
                        : ""
                    }`}
                    {...formik.getFieldProps("otherReason")}
                  ></textarea>
                  {formik.touched.otherReason && formik.errors.otherReason && (
                    <div className="invalid-feedback">
                      {formik.errors.otherReason}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className=" mb-4">
                <lable className="form-lable">
                  Centre Remark<span className="text-danger">*</span>
                </lable>

                <textarea
                  className={`form-control   ${
                    formik.touched.centerRemark && formik.errors.centerRemark
                      ? "is-invalid"
                      : ""
                  }`}
                  {...formik.getFieldProps("centerRemark")}
                ></textarea>
                {formik.touched.centerRemark && formik.errors.centerRemark && (
                  <div className="invalid-feedback">
                    {formik.errors.centerRemark}
                  </div>
                )}
              </div>
            </div>
          </div>
          <Modal.Footer className="mt-3">
            <Button
              className="btn btn-sm btn-border bg-light text-dark"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <button
              type="submit"
              className="btn btn-button btn-sm"
              disabled={loadIndicator}
            >
              {loadIndicator && (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  aria-hidden="true"
                ></span>
              )}
              Submit
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default StudentEndClassAdd;
